/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Card from "../../../../components/Cards/Card";
import { getPasswordPolicyValue } from "../../../../store/actions/remittance.action";
import { passwordMap } from "../../../../utils/helpers/objectHelpers";
import { RemittanceService } from "../../../../utils/services/remittance.service";

function Body({ domainBrand, passwordPolicies }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const dispatch = useDispatch();

  const passWordObject = passwordMap(dictionary).map((i) => {
    if (i.name === "enablePasswordPolicy") {
      i = { ...i, value: passwordPolicies?.enablePasswordPolicy };
    }
    if (i.name === "atleastOneUpperCase") {
      i = { ...i, value: passwordPolicies?.atleastOneUpperCase };
    }
    if (i.name === "atleastOneLowerCase") {
      i = { ...i, value: passwordPolicies?.atleastOneLowerCase };
    }
    if (i.name === "atleastOneSpecialCharacter") {
      i = { ...i, value: passwordPolicies?.atleastOneSpecialCharacter };
    }
    if (i.name === "atleastOneDigit") {
      i = { ...i, value: passwordPolicies?.atleastOneDigit };
    }
    return { ...i };
  });

  const [open] = useState(false);
  const [password, setPassword] = useState(false);
  const [passwordFields, setPasswordFields] = useState([...passWordObject]);
  const [minPassword, setMinPassword] = useState(passwordPolicies?.minLength);
  const [maxPassword, setMaxPassword] = useState(passwordPolicies?.maxLength);
  const [payload, setPayload] = useState({ ...passwordPolicies });
  const [checkFields, setCheckFields] = useState({ ...passwordPolicies });
  const [loading, setLoading] = useState(false);

  const onChangeEnableInput = (e) => {
    const temp = passwordFields.map((i) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setPasswordFields([...temp]);
    setPayload({
      ...payload,
      [e.target.name]: e.target.checked,
    });
    setCheckFields({
      ...checkFields,
      [e.target.name]: e.target.checked,
    });
  };

  const savePasswordPolicy = async (values) => {
    setLoading(true);
    try {
      const response = await RemittanceService.savePasswordPolicy(values);
      if (response.status === 200) {
        toast.success(response?.data?.message);
        setPayload({});
        setLoading(false);
        dispatch(getPasswordPolicyValue());
      } else {
        toast.error("couldn't save your password policy, please try again");
        setPayload({});
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const passwordObj = {
    minLength: parseInt(minPassword),
    maxLength: parseInt(maxPassword),
    atleastOneDigit: checkFields?.atleastOneDigit,
    atleastOneLowerCase: checkFields?.atleastOneLowerCase,
    atleastOneSpecialCharacter: checkFields?.atleastOneSpecialCharacter,
    atleastOneUpperCase: checkFields?.atleastOneUpperCase,
    enablePasswordPolicy: checkFields?.enablePasswordPolicy,
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["WO_PASSWORD_POLIC_2082308522"]
                : "Password Policy"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <Card>
              <ul className="list-group">
                <li
                  className="list-group-item collapse-text text-uppercase fw-bold"
                  onClick={() => setPassword(!password)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {password ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_PASSWORD_POLICY_SETT_506777189"]
                    : "PASSWORD POLICY SETTING"}
                </li>
                <Collapse in={password}>
                  <div id="example-collapse-text" className="px-3">
                    <label>
                      {dictionary
                        ? dictionary["WO_SELECT_THE_PASSWORD_543231990"]
                        : `Select the password policies fields your organization would like to have as mandatory.`}
                    </label>
                    <div className="form-row py-4">
                      {passwordFields.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 check-box"
                                  onChange={(e) => onChangeEnableInput(e)}
                                  // value={i.value}
                                  checked={i.value}
                                  defaultChecked={i.value}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row py-4">
                      <div className="col-lg-6 col-md-6">
                        <label>
                          {dictionary
                            ? dictionary["WO_PASSWORD_MINIMUM_LEN_-817966711"]
                            : `Password minimum length`}
                        </label>

                        <input
                          type={"number"}
                          className="form-control"
                          defaultValue={passwordPolicies?.minLength}
                          onChange={(e) => setMinPassword(e.target.value)}
                        />
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <label>
                          {dictionary
                            ? dictionary["WO_PASSWORD_MAXIMUM_LEN_-1646173016"]
                            : `Password maximum length`}
                        </label>

                        <input
                          type={"number"}
                          className="form-control"
                          defaultValue={passwordPolicies?.maxLength}
                          onChange={(e) => setMaxPassword(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => savePasswordPolicy(passwordObj)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                          type={"button"}
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
